import { render } from "./AppBaseSheet.vue?vue&type=template&id=a218a0ca&scoped=true"
import script from "./AppBaseSheet.vue?vue&type=script&lang=js"
export * from "./AppBaseSheet.vue?vue&type=script&lang=js"

import "./AppBaseSheet.vue?vue&type=style&index=0&id=a218a0ca&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a218a0ca"]])

export default __exports__